import { graphql } from 'msw';

export const strapi = graphql.link('http://localhost:3002/content/graphql');

const data = {
    circuitHubByDomain: {
        __typename: 'CircuitHub',
        id: '1',
        navigation: {
            items: [
                {
                    id: '1',
                    name: 'Home',
                    url: '/#home',
                    icon: null,
                    __typename: 'ComponentGenericNavigationItem',
                },
                {
                    id: '5',
                    name: 'Watch Live!',
                    url: '/tournaments',
                    icon: null,
                    __typename: 'ComponentGenericNavigationItem',
                },
                {
                    id: '26',
                    name: 'Statistics',
                    url: '/cover_gg',
                    icon: null,
                    __typename: 'ComponentGenericNavigationItem',
                },
                {
                    id: '22',
                    name: 'Rankings',
                    url: '/#regionalrankings',
                    icon: null,
                    __typename: 'ComponentGenericNavigationItem',
                },
                {
                    id: '6',
                    name: 'Schedule',
                    url: '/#schedule ',
                    icon: null,
                    __typename: 'ComponentGenericNavigationItem',
                },
                {
                    id: '23',
                    name: 'Blog',
                    url: 'https://medium.com/champion-of-champions-tour',
                    icon: null,
                    __typename: 'ComponentGenericNavigationItem',
                },
                {
                    id: '24',
                    name: 'Broadcast Partners',
                    url: 'https://cctour.gg/broadcast_partners',
                    icon: null,
                    __typename: 'ComponentGenericNavigationItem',
                },
            ],
            __typename: 'ComponentGenericNavigation',
        },
        tourLogo: {
            id: '430',
            alt_text: 'Champion of Champions Tour',
            image: {
                id: '3889',
                alternativeText: '',
                caption: '',
                width: 1000,
                height: 1000,
                url: 'https://cdn.grid.gg/strapi/logo_main_1986c42bf7.png',
                previewUrl: null,
                __typename: 'UploadFile',
            },
            __typename: 'ComponentImagesImage',
        },
        site: {
            id: '62',
            domain: 'cctour.gg',
            site_title: 'Champion of Champions Tour',
            name: 'Champion of Champions Tour',
            brand: {
                id: '64',
                name: 'Champion of Champions Tour',
                primary_colors: ['#FFDE00', '#FFE042', '#FFD90F'],
                secondary_colors: ['#dbb251'],
                light_colors: ['#f2f2f3', '#e5e5e8', '#d9d9dc', '#ccccd0'],
                dark_colors: ['#0F0F0F', '#0F0F0F', '#0F0F0F', '#0F0F0F'],
                slate_colors: ['#92929c', '#858590', '#797985', '#6d6d78'],
                theme_overrides: {
                    colourScheme: 'dark',
                    fonts: ["'Fjalla One', sans-serif", "'Lato', sans-serif"],
                    fontImports: [
                        "@import url('https://fonts.googleapis.com/css2?family=Fjalla+One&family=Lato:wght@300&display=swap');",
                    ],
                    colors: {
                        base: {
                            '0': '#FFFFFF',
                            '5': '#F2F2F2',
                            '10': '#E6E6E6',
                            '15': '#D9D9D9',
                            '20': '#CCCCCC',
                            '25': '#BFBFBF',
                            '30': '#B2B2B2',
                            '35': '#A6A6A6',
                            '40': '#999999',
                            '45': '#8C8C8C',
                            '50': '#808080',
                            '55': '#737373',
                            '60': '#666666',
                            '65': '#595959',
                            '70': '#4D4D4D',
                            '75': '#404040',
                            '80': '#090808',
                            '85': '#090808',
                            '90': '#1A1A1A',
                            '95': '#0D0D0D',
                            '100': '#000000',
                        },
                    },
                    heading: {
                        size: {
                            h1: { fontSize: '32px', fontFamily: 0, lineHeight: '64px' },
                            h2: { fontSize: '28x', fontFamily: 0, lineHeight: '48px' },
                            h3: { fontSize: '24px', fontFamily: 0, lineHeight: '40px' },
                            h4: { fontSize: '20px', fontFamily: 0, lineHeight: '32px' },
                            h5: { fontSize: '16px', fontFamily: 1, lineHeight: '20px' },
                            h6: { fontSize: '14px', fontFamily: 1, lineHeight: '12px' },
                        },
                    },
                    text: {
                        size: {
                            large: {
                                fontSize: '18px',
                                lineHeight: '24px',
                                fontFamily: 1,
                                fontWeight: 300,
                            },
                            medium: {
                                fontSize: '16px',
                                lineHeight: '24px',
                                fontFamily: 1,
                                fontWeight: 300,
                            },
                            small: {
                                fontSize: '14px',
                                lineHeight: '20px',
                                fontFamily: 1,
                                fontWeight: 300,
                            },
                            xSmall: {
                                fontSize: '12px',
                                lineHeight: '16px',
                                fontFamily: 1,
                                fontWeight: 300,
                            },
                        },
                    },
                },
                __typename: 'Brand',
            },
            socials: {
                id: '60',
                facebook: null,
                instagram: null,
                linkedin: null,
                twitch: 'https://www.twitch.tv/cct_en',
                twitter: 'https://twitter.com/cctour_gg',
                youtube: 'https://www.youtube.com/channel/UCrN2GuYzV7D8hcyMrq7ImUA',
                __typename: 'ComponentSocialSocials',
            },
            sponsors: [
                {
                    id: '158',
                    link: 'https://bitskins.com',
                    name: 'Bitskins2',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 755,
                        height: 488,
                        url: 'https://cdn.grid.gg/strapi/bitskins_logo_86c0139885.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '161',
                    link: 'https://www.gamingmalta.org/',
                    name: 'GamingMalta',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 2248,
                        height: 753,
                        url: 'https://cdn.grid.gg/strapi/Gaming_Malta_62a2be4af4.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '212',
                    link: ' https://www.grid.gg',
                    name: 'GRID',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 755,
                        height: 488,
                        url: 'https://cdn.grid.gg/strapi/GRID_LOGO_a3815a64e7.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '215',
                    link: 'https://parimatch.com',
                    name: 'Bitskins',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 755,
                        height: 488,
                        url: 'https://cdn.grid.gg/strapi/parimatch_logo_86735f97ea.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '216',
                    link: 'https://prosper.games/',
                    name: 'Prosper Ultimate',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 755,
                        height: 488,
                        url: 'https://cdn.grid.gg/strapi/prosper_logo_a1455b4be8.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '217',
                    link: 'https://arterra.co/',
                    name: 'Arterra Labs',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 755,
                        height: 488,
                        url: 'https://cdn.grid.gg/strapi/arterra_logo_2ee35fc220.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '218',
                    link: 'https://www.streamcards.gg/',
                    name: 'StreamCards',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 755,
                        height: 488,
                        url: 'https://cdn.grid.gg/strapi/streamcard1_ee60fe4190.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '219',
                    link: 'https://aws.amazon.com/?nc2=h_lg',
                    name: 'AWS',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 755,
                        height: 488,
                        url: 'https://cdn.grid.gg/strapi/aws_logo_2a657714bb.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
                {
                    id: '220',
                    link: 'https://hellcase.com/',
                    name: 'Hellcase',
                    image: {
                        alternativeText: '',
                        caption: '',
                        width: 2984,
                        height: 672,
                        url: 'https://cdn.grid.gg/strapi/hellcase_white_3a56914951.png',
                        previewUrl: null,
                        __typename: 'UploadFile',
                    },
                    __typename: 'Sponsor',
                },
            ],
            __typename: 'Site',
        },
        footer: {
            linksColumnLeft: {
                items: [
                    {
                        name: 'Privacy Policy',
                        url: '/',
                        __typename: 'ComponentGenericNavigationItem',
                    },
                    {
                        name: 'Cookie Policy',
                        url: '/',
                        __typename: 'ComponentGenericNavigationItem',
                    },
                    {
                        name: 'GRID',
                        url: 'http://grid.gg',
                        __typename: 'ComponentGenericNavigationItem',
                    },
                    {
                        name: 'Press',
                        url: 'https://cctour.gg/press',
                        __typename: 'ComponentGenericNavigationItem',
                    },
                    {
                        name: 'Rules',
                        url: 'https://cctour.gg/detailed_rules',
                        __typename: 'ComponentGenericNavigationItem',
                    },
                ],
                title: 'Links',
                __typename: 'ComponentGenericNavigation',
            },
            linksColumnRight: {
                items: [
                    {
                        name: 'General Inquiries ',
                        url: 'mailto:cct-support@grid.gg',
                        __typename: 'ComponentGenericNavigationItem',
                    },
                    {
                        name: 'Broadcast & Commentators',
                        url: 'mailto:cct-broadcast@grid.gg',
                        __typename: 'ComponentGenericNavigationItem',
                    },
                ],
                title: 'Contacts',
                __typename: 'ComponentGenericNavigation',
            },
            __typename: 'ComponentCircuitHubFooter',
        },
        content_pages: [
            {
                __typename: 'ContentPage',
                meta: {
                    __typename: 'ComponentPageComponentsMeta',
                    slug: 'press',
                    title: 'Press Page',
                },
                content: [
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '13',
                        sectionId: 'Welcome',
                        text: {
                            id: '9',
                            title: '',
                            subtitle: null,
                            description: null,
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '12',
                            content: {
                                id: '444',
                                alt_text: null,
                                image: {
                                    id: '4194',
                                    alternativeText: '',
                                    caption: '',
                                    width: 4418,
                                    height: 1496,
                                    url: 'https://cdn.grid.gg/strapi/CCT_2022_2024_00f7dc5082.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'stretch',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: null,
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '76',
                        sectionId: 'SCHEDULE RELEASE',
                        text: {
                            id: '40',
                            title: 'CCT Announces Tournament Schedule for 2022-2024',
                            subtitle: 'The CCT calendar released!',
                            description:
                                'The Champion of Champions Tour aims to consolidate regional partners and industry leaders into one robust tournament circuit. Taking place between August 2022 and January 2024, the 18-month Tour will see each of the seven regions participating in a unified format across each stage of the Tour (Online/Studio/Arena). CCT’s Global Finals will bring the regions together to battle it out and claim the grand prize. ',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '73',
                            content: {
                                id: '584',
                                alt_text: null,
                                image: {
                                    id: '4477',
                                    alternativeText: '',
                                    caption: '',
                                    width: 816,
                                    height: 604,
                                    url: 'https://cdn.grid.gg/strapi/announcement_df10c881de.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '141',
                            text: 'Check the dates',
                            href:
                                'https://www.hltv.org/news/34280/champion-of-champions-tour-first-phase-schedule-revealed',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '114',
                        sectionId: 'Medium',
                        text: {
                            id: '73',
                            title: 'CCT Medium',
                            subtitle: null,
                            description:
                                'Visit the CCT Blog to find out more about the CCT Structure, Tournament updates, and stay up to date with the recent news.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '93',
                            content: {
                                id: '610',
                                alt_text: null,
                                image: {
                                    id: '4590',
                                    alternativeText: '',
                                    caption: '',
                                    width: 621,
                                    height: 441,
                                    url:
                                        'https://cdn.grid.gg/strapi/press_page_medium_b211dc1e14.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '147',
                            text: 'Check our news',
                            href: 'https://medium.com/champion-of-champions-tour',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '54',
                        sectionId: 'BITSKINS',
                        text: {
                            id: '38',
                            title: 'BitSkins Named Official Partner of CCT',
                            subtitle: 'The official skin marketplace partner of CCT',
                            description:
                                'The partnership will see BitSkins, the leading CS:GO skin marketplace, becoming the Official Skin Marketplace Partner for the Main Broadcast of the Champion of Champions Tour, one of the largest CS:GO global tour, for the entirety of the tournament.\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '52',
                            content: {
                                id: '524',
                                alt_text: null,
                                image: {
                                    id: '4153',
                                    alternativeText: '',
                                    caption: '',
                                    width: 816,
                                    height: 604,
                                    url:
                                        'https://cdn.grid.gg/strapi/bitskinsannouncement_2c1695285e.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '108',
                            text: 'BitSkins Partnership',
                            href:
                                'https://esportsinsider.com/2022/06/csgo-circuit-champion-of-champions-tour-partners-with-bitskins/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '53',
                        sectionId: 'CCT 22-24',
                        text: {
                            id: '37',
                            title: 'CCT 22-24',
                            subtitle: 'The Champions of Champions Tour is here',
                            description:
                                'The Champion of Champions Tour (CCT), is the first International CS:GO Tour to be jointly organised by leading esports companies including FACEIT, Eden Esports, Relog Media, Black Molly Entertainment, Fantasy Expo, and regional organisers, commissioned by GRID Esports, is set to start in July 2022 and end with a Global LAN Finals in January 2024.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '51',
                            content: {
                                id: '521',
                                alt_text: null,
                                image: {
                                    id: '4101',
                                    alternativeText: '',
                                    caption: '',
                                    width: 816,
                                    height: 604,
                                    url: 'https://cdn.grid.gg/strapi/announcement_0f1ac65b8b.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '107',
                            text: 'CCT 22-24',
                            href: 'https://www.accesswire.com/viewarticle.aspx?id=700406',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '14',
                        sectionId: 'HSH',
                        text: {
                            id: '10',
                            title: 'Home Sweet Home - March 2020',
                            subtitle: 'The Path to Champion of Champions Tour 22-24',
                            description:
                                'In March 2020 GRID esports launched a tournament initiative during the height of the pandemic to tackle the volatility and shortage of content prevailing to its partners. Relog Media collaborated in organizing a series of 6 cups that accumulated a $320,000 prize pool.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '13',
                            content: {
                                id: '445',
                                alt_text: null,
                                image: {
                                    id: '3673',
                                    alternativeText: '',
                                    caption: '',
                                    width: 408,
                                    height: 302,
                                    url: 'https://cdn.grid.gg/strapi/announcement_b068735c65.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '99',
                            text: 'Home Sweet Home',
                            href:
                                'https://www.hltv.org/news/29299/homesweethome-tournament-series-announced-with-320000-in-prizes-godsent-north-forze-first-confirmed-teams',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '15',
                        sectionId: 'SSS',
                        text: {
                            id: '11',
                            title: ' Seasonal Content Extension - December 2020',
                            subtitle: 'The Path to Champions Tour 22-24',
                            description:
                                'Across 2021 the Home Sweet Home Series was extended to provide seasonal content and provide more sustainable and regular content through the CSGO tiers. Across 2021 12 Cups were produced within this range distributing $1,100,000 in the prize pool across the CSGO ecosystem.\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '14',
                            content: {
                                id: '446',
                                alt_text: null,
                                image: {
                                    id: '3866',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1050,
                                    height: 763,
                                    url: 'https://cdn.grid.gg/strapi/press_HSH_573d9a7e64.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '100',
                            text: 'Snow Sweet Snow - Seasonal Tournaments',
                            href:
                                'https://www.hltv.org/news/30819/snow-sweet-snow-tournament-series-unveiled-with-300000-prize-pool',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '16',
                        sectionId: 'CCT',
                        text: {
                            id: '12',
                            title: 'CCT Alpha! ',
                            subtitle: 'The Path to Champions Tour 22-24',
                            description:
                                'Through 2021 GRID esports started to recognize its role as a consolidator of content within the Tier 2 scene. Partnering with Eden Esports, Relog Media, Funspark, and Elisa Esports initially to provide the first substantial effort in respect to supporting Tournament Organisation within the game title. \n\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '15',
                            content: {
                                id: '447',
                                alt_text: null,
                                image: {
                                    id: '3675',
                                    alternativeText: '',
                                    caption: '',
                                    width: 408,
                                    height: 302,
                                    url: 'https://cdn.grid.gg/strapi/Announcement1_1434741d9c.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '101',
                            text: 'Champion of Champions - Alpha Season',
                            href:
                                'https://www.hltv.org/news/31629/elisa-relog-media-funspark-unite-to-form-27m-event-circuit-for-2021-2022',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '17',
                        sectionId: 'LAN',
                        text: {
                            id: '13',
                            title: 'BME x GRID x Pinnacle create Swedish Arena LAN',
                            subtitle: 'The Path to Champions Tour 22-24',
                            description:
                                'In June 2022, GRID esports, BME, and long-term partner Pinnacle Sports produced the first arena LAN in connection with the Champions Tour. Held in the City of Lund, Sweden, the Pinnacle Cup Championship shall be the first of the collection of major events across the initial conception of the CCT following the $250,000 Funspark Grand Finals in January.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '16',
                            content: {
                                id: '448',
                                alt_text: null,
                                image: {
                                    id: '3676',
                                    alternativeText: '',
                                    caption: '',
                                    width: 408,
                                    height: 301,
                                    url: 'https://cdn.grid.gg/strapi/4_ebf4023374.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: {
                            id: '102',
                            text: 'Entering LAN Tournaments',
                            href:
                                'https://esportsinsider.com/2022/03/pinnacle-cup-championship-finals-set-to-take-place-in-lund-sweden/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                ],
                footer: null,
                navigation: null,
                backbutton: {
                    text: 'BACK TO WELCOME PAGE',
                    __typename: 'ComponentCircuitHubBackButton',
                },
            },
            {
                __typename: 'ContentPage',
                meta: {
                    __typename: 'ComponentPageComponentsMeta',
                    slug: 'partnerships_overview',
                    title: 'Partnerships Overview',
                },
                content: [
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '20',
                        sectionId: 'Welcome1',
                        text: {
                            id: '16',
                            title: '',
                            subtitle: null,
                            description: null,
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '20',
                            content: {
                                id: '452',
                                alt_text: null,
                                image: {
                                    id: '4471',
                                    alternativeText: '',
                                    caption: '',
                                    width: 846,
                                    height: 360,
                                    url:
                                        'https://cdn.grid.gg/strapi/Foundational_partners_new_d2eed1c7e4.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'stretch',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: null,
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '24',
                        sectionId: 'grid',
                        text: {
                            id: '19',
                            title: 'GRID',
                            subtitle: '',
                            description:
                                '#### **About the company**\n\nGRID Esports is the official esports and gaming data platform for the CCT. GRID specializes in in-Game, play-by-play data. GRID has been the data partner of over 85 tournament organizers and game publishers, including BLAST Premier, PGL, WePlay Esports, PUBG, and Riot Games.\n\n\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '24',
                            content: {
                                id: '456',
                                alt_text: null,
                                image: {
                                    id: '4012',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2066,
                                    height: 1022,
                                    url: 'https://cdn.grid.gg/strapi/grid_cct_bafb039471.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '13',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '85',
                            text: 'Visit GRID',
                            href: 'https://grid.gg/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '23',
                        sectionId: 'faceit',
                        text: {
                            id: '18',
                            title: 'FACEIT',
                            subtitle: '',
                            description:
                                '#### **About the company**\n\nFACEIT is the leading independent competitive gaming platform for online multiplayer PvP gamers with more than twenty million users worldwide.\n\n\n\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '23',
                            content: {
                                id: '455',
                                alt_text: null,
                                image: {
                                    id: '3703',
                                    alternativeText: '',
                                    caption: '',
                                    width: 892,
                                    height: 320,
                                    url: 'https://cdn.grid.gg/strapi/Frame_1778_1b855a6ad9.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '12',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '84',
                            text: 'Visit FACEIT',
                            href: 'https://www.faceit.com/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '26',
                        sectionId: 'relog',
                        text: {
                            id: '21',
                            title: 'RELOG MEDIA',
                            subtitle: '',
                            description:
                                '#### **About the company**\n\nRelog Media is a tournament organizer and production company behind the Home Sweet Home series organized together with GRID, and manages the TV Arena Esport, a linear TV channel in the Adria region. Relog also operates a boot camp facility that has hosted numerous high-profile teams such as Cloud9, G2 Esports, FaZe Clan, and MIBR.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '26',
                            content: {
                                id: '458',
                                alt_text: null,
                                image: {
                                    id: '3706',
                                    alternativeText: '',
                                    caption: '',
                                    width: 892,
                                    height: 320,
                                    url: 'https://cdn.grid.gg/strapi/Frame_1781_4eeb717a91.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '15',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '87',
                            text: 'Visit RELOG MEDIA',
                            href: 'https://www.relog.rs/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '27',
                        sectionId: 'edenesports',
                        text: {
                            id: '22',
                            title: 'EDEN ESPORTS',
                            subtitle: '',
                            description:
                                '#### **About the company**\n\nEden Esports is the largest Malta-based esports tournament organizer. Eden host online and offline international esports events such as SuperNova, Champions Cup, EDC, and Malta Vibes series.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '27',
                            content: {
                                id: '459',
                                alt_text: null,
                                image: {
                                    id: '3708',
                                    alternativeText: '',
                                    caption: '',
                                    width: 892,
                                    height: 320,
                                    url: 'https://cdn.grid.gg/strapi/Frame_1782_5dd458336d.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '16',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '88',
                            text: 'Visit EDEN ESPORTS',
                            href: 'https://edenesports.com/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '28',
                        sectionId: 'fantasyexpo',
                        text: {
                            id: '23',
                            title: 'FANTASY EXPO',
                            subtitle: '',
                            description:
                                '#### **About the company**\n\nOne of the largest talent management agencies operating across Central and Eastern Europe, cooperating closely with Twitch and YouTube eSport and gaming stars providing content production for multiple brands.\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '28',
                            content: {
                                id: '460',
                                alt_text: null,
                                image: {
                                    id: '3709',
                                    alternativeText: '',
                                    caption: '',
                                    width: 892,
                                    height: 320,
                                    url: 'https://cdn.grid.gg/strapi/Frame_1783_59d1e24aac.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '17',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '89',
                            text: 'Visit FANTASY EXPO',
                            href: 'https://www.fantasyexpo.pl/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '22',
                        sectionId: 'Welcome2',
                        text: null,
                        image: {
                            id: '22',
                            content: {
                                id: '454',
                                alt_text: null,
                                image: {
                                    id: '4470',
                                    alternativeText: '',
                                    caption: '',
                                    width: 846,
                                    height: 360,
                                    url:
                                        'https://cdn.grid.gg/strapi/Regional_partners_new_d5af38a3ea.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'stretch',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: null,
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '29',
                        sectionId: 'bts',
                        text: {
                            id: '24',
                            title: 'BTSBrasilTV',
                            subtitle: 'South America',
                            description:
                                '#### **About the company**\n\nBTSBrasilTV is the largest independent studio in Latin America, active since 2017, specializing in esports coverage and casting, bringing professional coverage of events from all over the world of esports to spectators worldwide.\n\n#### **Regional Coverage**\n\n8 x Online Cups - $200 000 Prize Pool',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '29',
                            content: {
                                id: '461',
                                alt_text: null,
                                image: {
                                    id: '4162',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2112,
                                    height: 1324,
                                    url: 'https://cdn.grid.gg/strapi/BTS_Brazil_11ed6e22fe.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '18',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '90',
                            text: 'Visit BTSBrasilTV',
                            href: 'https://btsbrasil.tv/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '30',
                        sectionId: 'fireesports',
                        text: {
                            id: '25',
                            title: 'FIRESPORTS',
                            subtitle: 'North America',
                            description:
                                '#### **About the company**\n\nFIReSPORTS is a Latin America-based Tournament Operator. With a strong presence across the LATAM and Iberian scene, FIReSPORTS are excited to showcase their abilities to the NA community by hosting their events together with us.\n\n#### **Regional Coverage**\n\n8 x Online Cups $200 000 Prize Pool\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '30',
                            content: {
                                id: '462',
                                alt_text: null,
                                image: {
                                    id: '4160',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2112,
                                    height: 1324,
                                    url: 'https://cdn.grid.gg/strapi/Firesports_d15160796e.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '19',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '92',
                            text: 'Visit FIRESPORTS',
                            href: 'https://firesports.gg/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '32',
                        sectionId: 'tba',
                        text: {
                            id: '27',
                            title: 'GAM3RS_X',
                            subtitle: 'North Europe',
                            description:
                                "#### **About the company**\n\nGAM3RS_X is a gaming agency established in 2022. It is part of the Fantasyexpo group and is formed by specialists who have been creating and delivering top-quality esports and gaming products for years. The agency's portfolio includes projects for BLAST or Eden Esports.  They also work with a range of world-renowned brands such as Logitech G, Steel Series, KFC, and many others. \n\n#### **Regional Coverage**\n\n8 x  Online Cups $400 000 Prize Pool",
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '32',
                            content: {
                                id: '464',
                                alt_text: null,
                                image: {
                                    id: '4581',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2230,
                                    height: 1324,
                                    url: 'https://cdn.grid.gg/strapi/Gam3rs_X_bff54b49b3.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '21',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '93',
                            text: 'TBA',
                            href: '',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '33',
                        sectionId: 'weplay',
                        text: {
                            id: '28',
                            title: 'RELOG MEDIA',
                            subtitle: 'East Europe',
                            description:
                                '#### **About the company**\n\nRelog is a tournament organizer and production company behind the series Home Sweet Home organized together with GRID and manages the TV Arena Esport, a linear TV channel in the Adria region. Relog also operates a boot camp facility that has hosted numerous high-profile teams such as Cloud9, G2 Esports, FaZe Clan, and MIBR.\n\n#### **Regional Coverage**\n\n4 x Online Cups $200 000 Prize Pool',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '33',
                            content: {
                                id: '465',
                                alt_text: null,
                                image: {
                                    id: '4163',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2112,
                                    height: 1324,
                                    url: 'https://cdn.grid.gg/strapi/Relog_ef60377611.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '22',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '94',
                            text: 'Visit RELOG MEDIA',
                            href: 'https://www.relog.rs/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '34',
                        sectionId: 'gjirafa',
                        text: {
                            id: '29',
                            title: 'GJIRAFA',
                            subtitle: 'South Europe',
                            description:
                                '#### **About the company**\n\nGjirafa is the organiser of Gjirafa50 Masters League, the leading CS:GO league in the Balkans sponsored by Vodafone, Raiffeisen Bank or KFC.\n\n#### **Regional Coverage**\n\n4 x Online Cups $200 000 Prize Pool',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '34',
                            content: {
                                id: '466',
                                alt_text: null,
                                image: {
                                    id: '4165',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2778,
                                    height: 1324,
                                    url: 'https://cdn.grid.gg/strapi/Gjirafa_977b73ccf9.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '23',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '95',
                            text: 'Visit GJIRAFA',
                            href: 'https://gjirafa.com/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '35',
                        sectionId: 'fragster',
                        text: {
                            id: '30',
                            title: 'FRAGSTER',
                            subtitle: 'West Europe',
                            description:
                                "#### **About the company**\n\nFragster is a German-based Tournament Operator who is born out of a passion for the scene. Their objective of raising the quality and quantity of events within Germany is a perfect alignment for CCT. We'll be seeing Fragster deliver the Western Europe competitions and helping the scene to expand.\n\n#### **Regional Coverage**\n\n4 x Online Cups $200 000 Prize Pool",
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '35',
                            content: {
                                id: '467',
                                alt_text: null,
                                image: {
                                    id: '4164',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2112,
                                    height: 1324,
                                    url: 'https://cdn.grid.gg/strapi/Fragster_42da28d525.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '24',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '96',
                            text: 'Visit FRAGSTER',
                            href: 'https://www.fragster.de/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '36',
                        sectionId: 'cnc',
                        text: {
                            id: '31',
                            title: 'REPUBLEAGUE',
                            subtitle: 'Central Europe',
                            description:
                                '#### **About the company**\n\nREPUBLEAGUE is a tournament organizer and a production company based in Slovakia. Their main vision is to create a bridge between the Czechoslovak region and the rest of the World.\nREPUBLEAGUE believes it will be further developed by entering into a partnership with CCT.\n\n#### **Regional Coverage**\n\n8 x Online Cups $400 000 Prize Pool',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '36',
                            content: {
                                id: '468',
                                alt_text: null,
                                image: {
                                    id: '4161',
                                    alternativeText: '',
                                    caption: '',
                                    width: 2112,
                                    height: 1324,
                                    url: 'https://cdn.grid.gg/strapi/Repub_League_4a76c0d777.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '25',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '97',
                            text: 'Visit REPUBLEAGUE',
                            href: 'https://www.instagram.com/republeague',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                ],
                footer: null,
                navigation: null,
                backbutton: {
                    text: 'BACK TO WELCOME PAGE',
                    __typename: 'ComponentCircuitHubBackButton',
                },
            },
            {
                __typename: 'ContentPage',
                meta: {
                    __typename: 'ComponentPageComponentsMeta',
                    slug: 'detailed_rules',
                    title: 'Detailed Rules',
                },
                content: [
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '78',
                        sectionId: 'purpose',
                        text: {
                            id: '42',
                            title: 'PURPOSE',
                            subtitle: null,
                            description:
                                'The sole purpose of the Point System is to grant the most consistent teams in the circuit spots at the Studio LAN Events and the Global Finals Event.\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: null,
                        style: {
                            id: '35',
                            backgroundColor: '',
                            backgroundType: 'none',
                            verticalSpace: 'none',
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: null,
                        video: {
                            url:
                                'https://www.youtube.com/watch?v=be7uHNK013A&ab_channel=ChampionofChampionsTour',
                            position: 'right',
                            __typename: 'ComponentCircuitHubVideo',
                        },
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '109',
                        sectionId: 'CCT Core Events',
                        text: {
                            id: '72',
                            title: 'CCT CORE EVENTS',
                            subtitle: null,
                            description:
                                '### OVERVIEW\n\nOnline Series and Studio Finals events will constitute the main pool of the Point Tournaments. After each Point Tournament is over, participants get points based on their performance. Point amounts and distribution are tied to the type of tournament. ',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: null,
                        style: null,
                        action: null,
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '111',
                        sectionId: 'onlineseries',
                        text: null,
                        image: {
                            id: '90',
                            content: {
                                id: '607',
                                alt_text: null,
                                image: {
                                    id: '4571',
                                    alternativeText: '',
                                    caption: '',
                                    width: 3135,
                                    height: 2529,
                                    url: 'https://cdn.grid.gg/strapi/Frame_17964_3bea6176d3.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'stretch',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: null,
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '81',
                        sectionId: 'foundationalevents',
                        text: {
                            id: '45',
                            title: 'CCT FOUNDATIONAL EVENTS',
                            subtitle: null,
                            description:
                                'CCT Foundational Events (e.g., National Leagues, Malta Vibes, etc.) will also be part of the Point Tournaments pool. For all calculations regarding the Global Rankings, these events will be treated as Online Series. National League scores will also count towards their respective Regional Rankings. ',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '76',
                            content: {
                                id: '595',
                                alt_text: null,
                                image: {
                                    id: '4565',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1641,
                                    height: 2400,
                                    url:
                                        'https://cdn.grid.gg/strapi/Open_tour_points_3897db71d8.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '37',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: 'top',
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: null,
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubTabsSection',
                        id: '7',
                        sectionId: 'regionalandglobalrankings',
                        title: 'REGIONAL AND GLOBAL RANKINGS',
                        tabs: [
                            {
                                id: '40',
                                title: 'Regional Rankings',
                                content: [
                                    {
                                        __typename: 'ComponentCircuitHubBasicSection',
                                        id: '87',
                                        sectionId: 'regionalranking',
                                        text: {
                                            id: '51',
                                            title: 'Regional Rankings',
                                            subtitle: null,
                                            description:
                                                'This is the total amount of points accumulated over the course of the 4 Online Series (and the relevant National Leagues) in a regional tranche. The top 3 point earners get a spot at the respective Studio Finals. There will be separate regional rankings for all 11 Studio Finals events.\n\n# **Tiebreakers**\n\nIf two or more teams have the same number of points, their head-to-head results over the course of the four (4) Online Series will determine qualification.\nIf teams are still tied after head-to-head, the total number of maps won will serve as a tiebreaker.\n\nThe final decider, in case of parity after all other tiebreakers, is the round difference.\n',
                                            __typename: 'ComponentCircuitHubSectionText',
                                        },
                                        image: null,
                                        style: null,
                                        action: null,
                                        video: null,
                                    },
                                ],
                                __typename: 'ComponentCircuitHubSectionTab',
                            },
                            {
                                id: '41',
                                title: 'Global Ranking',
                                content: [
                                    {
                                        __typename: 'ComponentCircuitHubBasicSection',
                                        id: '86',
                                        sectionId: 'globalranking',
                                        text: {
                                            id: '50',
                                            title: 'Global Ranking',
                                            subtitle: null,
                                            description:
                                                'This is the sum of the top 3 Online Series scores and the top 1 Studio Finals score for a team out of all the Online Series and Studio Finals that team played over the course of the CCT. The 2 highest-ranked teams will get spots at the Global Finals event. \n\n# **Tiebreakers**\n\n If two or more teams have the same number of points, the 4th best Online Series result will serve as a tiebreaker, followed by the total number of maps won. \n\nThe final decider, in case of parity after all other tiebreakers, is the round difference.',
                                            __typename: 'ComponentCircuitHubSectionText',
                                        },
                                        image: null,
                                        style: null,
                                        action: null,
                                        video: null,
                                    },
                                ],
                                __typename: 'ComponentCircuitHubSectionTab',
                            },
                        ],
                        style: {
                            id: '39',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: 'both',
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '108',
                        sectionId: 'pointsownership',
                        text: {
                            id: '71',
                            title: 'POINTS OWNERSHIP ',
                            subtitle: null,
                            description:
                                "### SPLIT\n\nThe organization owns 50% of the points earned in a tournament. Each of the five players, who participated in the majority of the matches for their team in that tournament, gets 10% of the points won. \n\nThis split matters when calculating the final points after roster changes. The team’s score from each tournament equals 50% of the points won by the organization plus 10% of the points won by each of the 5 players that constitute its current active roster. \n\n### MAJORITY TIEBREAKER\n\nIf there is a tie when determining the five players with the most matches, it’s broken based on the FACEIT registration - main players will receive the points over stand-ins, and stand-ins will receive the points over coaches.\n\n### TOURNAMENT SPECIFICITY\n\nThe point split is calculated for each tournament separately. Points can’t be transferred between tournaments. This means that when a player changes organizations, they can contribute only the points earned in tournaments that are relevant to their new organization's Regional and/or Global rankings.\n\n### PLAYER RULES\n\n1. A player gets 10% of the team tournament points only if they are among the 5 players that participated in the majority of the matches for their team in the respective tournament (e.g., if a stand-in comes in for just one fixture, they won’t get any points). \n \n2. A player contributes their points to the last organization for which they’ve played a CCT Point Tournament (participated in the majority of matches). \n\n3. When points are calculated, if an organization has more than 5 players that contribute points, then the top 5 point-earners are taken into account.\n\n4. A player can’t play for more than 1 organization over the course of a CCT Point tournament. If that happens, the player contributes their tournament points to neither of these organizations.\n\n### FULL POINTS TRANSFER\n\nIf an organization ceases to exist in the CCT circuit and the bulk of the players (3+) decide to form a new organization or just change the name of the old one, then all the organization points will be transferred (instead of just the player points), since the new organization will be considered identical to the old one (rules for player points transfer still apply as usual). \n\n### DISQUALIFICATION & FORFEITURE\n\nIf a team leaves or gets disqualified from CCT during any ongoing stage, whether it’s qualifiers or the playoffs, the participant forfeits all CCT points accumulated in that tournament. The teams securing a placement that awards CCT points as a result of a forfeiture or disqualification (e.g. finishing 5th in Play-ins stage and getting promoted to the Group Stage) are not entitled to the bonus CCT points awarded.",
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: null,
                        style: null,
                        action: null,
                        video: null,
                    },
                ],
                footer: null,
                navigation: null,
                backbutton: null,
            },
            {
                __typename: 'ContentPage',
                meta: {
                    __typename: 'ComponentPageComponentsMeta',
                    slug: 'broadcast_partners',
                    title: 'CCT Broadcast Partners',
                },
                content: [
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '115',
                        sectionId: 'Welcome2',
                        text: {
                            id: '74',
                            title: null,
                            subtitle: null,
                            description: null,
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '94',
                            content: {
                                id: '611',
                                alt_text: null,
                                image: {
                                    id: '4646',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1692,
                                    height: 720,
                                    url:
                                        'https://cdn.grid.gg/strapi/BROADCAST_PARTNERS_1a2fa1456a.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'stretch',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: null,
                        action: null,
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '116',
                        sectionId: 'BitSkins',
                        text: {
                            id: '75',
                            title: 'BITSKINS',
                            subtitle: null,
                            description:
                                "#### **About the company**\n\nOriginally founded in 2015 with the purpose of serving as a middleman for virtual gaming goods and cryptocurrencies, the company's services have continued to grow and they now support a wide variety of accommodations for everyone's needs. BitSkins is one of the most reputable virtual items platforms for CSGO skins and has been amongst leaders in the industry.",
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '95',
                            content: {
                                id: '612',
                                alt_text: null,
                                image: {
                                    id: '4600',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1377,
                                    height: 521,
                                    url: 'https://cdn.grid.gg/strapi/Bit_Skins_072499817f.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '40',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '148',
                            text: 'Visit BITSKINS',
                            href: 'https://bitskins.com/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '120',
                        sectionId: 'AWS',
                        text: {
                            id: '79',
                            title: 'AWS',
                            subtitle: null,
                            description:
                                '#### **About the company**\n\nFor over 15 years, Amazon Web Services has been the world’s most comprehensive and broadly adopted cloud offering. AWS has been continually expanding its services to support virtually any cloud workload, and it now has more than 200 fully featured services for compute, storage, databases, networking, analytics, machine learning and artificial intelligence (AI), Internet of Things (IoT), mobile, security, hybrid, virtual and augmented reality (VR and AR), media, and application development, deployment, and management.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '99',
                            content: {
                                id: '616',
                                alt_text: null,
                                image: {
                                    id: '4604',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1377,
                                    height: 521,
                                    url: 'https://cdn.grid.gg/strapi/aws_a6d02b4247.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '44',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '152',
                            text: 'Visit AWS',
                            href: 'https://aws.amazon.com/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '121',
                        sectionId: 'PariMatch',
                        text: {
                            id: '80',
                            title: 'PARIMATCH',
                            subtitle: null,
                            description:
                                "#### **About the company**\n\nParimatch is a global betting and technology brand that merges technology, business, and sport to deliver seamless entertainment powered by innovation. Founded in 1994, Parimatch has grown to become one of the leading betting brands in Africa, Asia, Europe, and Latin America. In several markets of those regions, Parimatch brand's expansion strategy is developed and implemented by a service company PMI. It provides tech, marketing, and communications services for its partners.\n",
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '100',
                            content: {
                                id: '617',
                                alt_text: null,
                                image: {
                                    id: '4605',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1377,
                                    height: 521,
                                    url: 'https://cdn.grid.gg/strapi/Parimatch_5294fe796e.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '45',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '153',
                            text: 'Visit PARIMATCH',
                            href: 'https://global.parimatch.com/en/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '125',
                        sectionId: 'Hellcase',
                        text: {
                            id: '83',
                            title: 'HELLCASE',
                            subtitle: null,
                            description:
                                '#### **About the company**\n\nHellcase is a case opening website with the biggest fan base over the World. You can choose one of dozens of unique cases, enjoy bright memorable design, play several improved or completely redesigned features like case battle and upgrader. Hellcase provides support for several esports tournaments as well as gives hundreds of skins for free to users in giveaways.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '104',
                            content: {
                                id: '633',
                                alt_text: null,
                                image: {
                                    id: '4642',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1199,
                                    height: 398,
                                    url: 'https://cdn.grid.gg/strapi/hellcase_white_08611522ea.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '48',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '164',
                            text: 'Visit HELLCASE',
                            href: 'https://hellcase.com/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '122',
                        sectionId: 'GamingMalta',
                        text: {
                            id: '81',
                            title: 'GAMINGMALTA',
                            subtitle: null,
                            description:
                                '#### **About the company**\n\nGamingMalta is an independent non-profit foundation set up by the Government of Malta and the Malta Gaming Authority (MGA). Tasked with the remit of promoting Malta as a Centre of excellence in the remote gaming sector globally, it is also responsible for liaising with the local relevant authorities to improve Malta’s attractiveness as a jurisdiction and enhance the ecosystem surrounding the gaming industry.',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '101',
                            content: {
                                id: '618',
                                alt_text: null,
                                image: {
                                    id: '4606',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1377,
                                    height: 520,
                                    url: 'https://cdn.grid.gg/strapi/Gaming_Malta_10224302b2.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '46',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '154',
                            text: 'Visit GAMINGMALTA',
                            href: 'https://www.gamingmalta.org/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '117',
                        sectionId: 'ARterra Labs',
                        text: {
                            id: '76',
                            title: 'ARTERRA LABS',
                            subtitle: null,
                            description:
                                '#### **About the company**\n\nARterra Labs is a scalable and user-friendly Web 3 platform that integrates directly into the Esports and gaming market. ARterra’s ecosystem includes an aggregate marketplace to find collectibles for sale and free to claim, a highly customizable API, and tournaments. ARterra is trusted by leading Esports organizations like Complexity Gaming and content creators worldwide, with new organizations and creators entering the ecosystem daily. \n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '96',
                            content: {
                                id: '613',
                                alt_text: null,
                                image: {
                                    id: '4601',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1377,
                                    height: 521,
                                    url: 'https://cdn.grid.gg/strapi/A_Rterra_41d398ee0b.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '41',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '149',
                            text: 'Visit ARTERRA LABS',
                            href: 'https://arterra.co/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '118',
                        sectionId: 'StreamCards',
                        text: {
                            id: '77',
                            title: 'STREAMCARDS',
                            subtitle: null,
                            description:
                                '#### **About the company**\n\nStreamCards is a gamification overlay that allows viewers to make micropredictions based on events in the underlying match directly on a Twitch stream in the form of a card game. Each microprediction card has a points value, and every card contributes to a viewer’s tournament score. Viewers are ranked based on their tournament score and can earn prizes for their active participation. ',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '97',
                            content: {
                                id: '614',
                                alt_text: null,
                                image: {
                                    id: '4602',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1377,
                                    height: 521,
                                    url: 'https://cdn.grid.gg/strapi/stream_Cards_3a9fe3f959.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'right',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '42',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '150',
                            text: 'Visit STREAMCARDS',
                            href: 'https://www.streamcards.gg/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                    {
                        __typename: 'ComponentCircuitHubBasicSection',
                        id: '119',
                        sectionId: 'Prosper',
                        text: {
                            id: '78',
                            title: 'PROSPER ULTIMATE',
                            subtitle: null,
                            description:
                                '#### **About the company**\n\nProsper Ultimate provides a unique experience to your current esports viewership with a bingo-style component that includes the thrill of rewards in large cash prizes.\nPrizes of up to $1,000,000 are won by simply guessing the player’s final kill scores on a tournament map of your choice. With a low barrier to entry of a modest $1 per entry ticket, Prosper is a great option for thrill chasers looking to add a little spice while watching their next esports match.\n',
                            __typename: 'ComponentCircuitHubSectionText',
                        },
                        image: {
                            id: '98',
                            content: {
                                id: '615',
                                alt_text: null,
                                image: {
                                    id: '4603',
                                    alternativeText: '',
                                    caption: '',
                                    width: 1377,
                                    height: 521,
                                    url: 'https://cdn.grid.gg/strapi/Prosper_f7c3f6e8a0.png',
                                    previewUrl: null,
                                    __typename: 'UploadFile',
                                },
                                __typename: 'ComponentImagesImage',
                            },
                            position: 'left',
                            __typename: 'ComponentCircuitHubSectionImage',
                        },
                        style: {
                            id: '43',
                            backgroundColor: 'base.85',
                            backgroundType: 'rectangle',
                            verticalSpace: null,
                            __typename: 'ComponentCircuitHubSectionStyle',
                        },
                        action: {
                            id: '151',
                            text: 'Visit PROSPER ULTIMATE',
                            href: 'https://prosper.games/',
                            variant: 'primary',
                            size: 'large',
                            __typename: 'ComponentButtonsButton',
                        },
                        video: null,
                    },
                ],
                footer: null,
                navigation: null,
                backbutton: {
                    text: 'BACK TO WELCOME PAGE',
                    __typename: 'ComponentCircuitHubBackButton',
                },
            },
            {
                __typename: 'ContentPage',
                meta: {
                    __typename: 'ComponentPageComponentsMeta',
                    slug: 'cover_gg',
                    title: 'Cover.gg',
                },
                content: [
                    {
                        __typename: 'ComponentCircuitHubExternalContent',
                        id: '1',
                        url: 'https://cover.gg/series/champion-of-champions-tour?dark=true',
                    },
                ],
                footer: null,
                navigation: null,
                backbutton: null,
            },
        ],
    },
};

export default strapi.query('GetContainPages', (req, res, ctx) => res(ctx.data(data)));
